import {interpolateColorHSLA} from "../util/color.js";

const nightColorConfig = {
    "cloud": {h: 227, s: 19, l: 43, a: 100},
    "rain": {h: 211, s: 23, l: 68, a: 100}
};


/**
 *
 * @param currentTemperature in Celsius
 * @return Number: color as int
 * Currently NOT USED
 */
function getTemperatureColor(currentTemperature) {
    if (currentTemperature >= 25) {
        return hot_color;
    } else if (currentTemperature >= 20) { // 20 - 25
        return interpolateColorHSLA(normal_color, hot_color, (currentTemperature - 20) / 5);
    }

    return normal_color;
}


/**
 * @param weatherType: string
 * @return {{cloud: {a: number, s: number, h: number, l: number}}}
 */
export function adaptColorsToWeather(weatherType) {

    let cloudColor = {h: 0, s: 0, l: 97, a: 100};
    let rainColor = {h: 218, s: 13, l: 62, a: 100};

    switch (weatherType) {
        case "snow":
        case "hail":
            cloudColor = {h: 0, s: 0, l: 100, a: 100};
            rainColor = {h: 213, s: 4, l: 52};
            break;
        case "rain":
            cloudColor = {h: 217, s: 7, l: 60, a: 100};
            rainColor = {h: 213, s: 4, l: 52};
            break;
        case "thunder":
        case "severe":
            cloudColor = {h: 207, s: 7, l: 51, a: 100};
            rainColor = {h: 213, s: 4, l: 52};
            break;
    }

    return {
        "cloud": cloudColor,
        "rain": rainColor
    }
}

/**
 * Makes color darker according to the time between sunset and sunrise.

 * @param colorConfig {{
 * cloud: {a: number, s: number, h: number, l: number}
 * }}
 * @param brightness {{number}} between 0 and 1
 * @return {{cloud: {a: number, s: number, h: number, l: number}}}
 */
export function adaptColorToDaytime(colorConfig, brightness) {
    if (brightness === 0) {
        // copy of night
        return {...nightColorConfig};
    } else if (brightness === 1) {
        return colorConfig;
    } else {
        // cloud colors have several stops during twilight
        if (brightness < 0.25) {
            colorConfig.cloud = interpolateColorHSLA({h: 0, s: 75, l: 65, a: 100}, nightColorConfig.cloud, 1-brightness*4);
        } else {
            colorConfig.cloud = interpolateColorHSLA(colorConfig.cloud, {h: 0, s: 75, l: 65, a: 100}, (1-brightness)*4/3);
        }
        colorConfig.rain = interpolateColorHSLA(colorConfig.rain, nightColorConfig.rain, 1-brightness);
        return colorConfig;
    }
}
